import { Card } from "@scuf/common";
import { Chart } from "@scuf/charts";
import React, { useEffect, useState } from "react";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";
import "../TGases.css";
import { plotBackground } from "../../../config/colors";

export default function PerfilTemperaturaTDG() {
  const [tempFreeboardA, setTempFreeboardA] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [tempFreeboardB, setTempFreeboardB] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [tempCiclonL1, setTempCiclonL1] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [tempCiclonL2, setTempCiclonL2] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [tempEntradaHESP, setTempEntradaHESP] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [tempSalidaCPC, setTempSalidaCPC] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [tempSalidaTorre, setTempSalidaTorre] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [tempSalidaHESP, setTempSalidaHESP] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  // Fecha inicial y final
  const [date, setDate] = useState({ start: "19-01-2023", end: "25-01-2023" });

  // Objeto inicial de la peticion
  const initialFetch = {
    idSeccion: 3,
    secuencia: 16,
    ultimo: 0,
    frecuencia: 5,
    dias: 7,
  };

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      // Solo nos traemos la data de la peticion
    const { data } = await getValoresPeriodo(initialFetch);

    populateTempFreeboardA(data);
    populateTempFreeboardB(data);
    populateTempCiclonL1(data);
    populateTempCiclonL2(data);
    populateTempEntradaHESP(data);
    populateTempSalidaCPC(data);
    populateTempSalidaTorre(data);
    populateTempSalidaHESP(data);
      //#endregion
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populateTempFreeboardA(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Temperatura Freeboard A"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setTempFreeboardA({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateTempFreeboardB(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Temperatura Freeboard B"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setTempFreeboardB({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateTempCiclonL1(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Temperatura Salida Ciclón L1"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setTempCiclonL1({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateTempCiclonL2(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Temperatura Salida Ciclón L2"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setTempCiclonL2({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateTempEntradaHESP(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Temperatura Entrada HESP"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setTempEntradaHESP({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateTempSalidaCPC(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Temperatura Salida CPC"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setTempSalidaCPC({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateTempSalidaTorre(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Temperatura Salida Torre Enfriamiento"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setTempSalidaTorre({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateTempSalidaHESP(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Temperatura Salida HESP"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setTempSalidaHESP({
      fecha: arrFechas,
      value: arrValues,
    });
  }

 
  return (
    <>
       <Card>
        <Card.Content>
          <Chart
            plotBackgroundColor={plotBackground}
            title={"Perfil Temperatura Tren de Gases"}
            subtitle={"Periodo " + date.start + " - " + date.end}
          >
            {/** -------------------------------- Temp. Freeboard A --------------------------------------- */}
            <Chart.Line
              name="Temp. Freeboard A"
              data={tempFreeboardA.value}
              yAxis={0}
            />
            {/** -------------------------------- Temp. Freeboard B --------------------------------------- */}
            <Chart.Line
              name="Temp. Freeboard B"
              data={tempFreeboardB.value}
              yAxis={0}
            />
            {/** -------------------------------- Temp. Salida Ciclón L1 --------------------------------------- */}
            <Chart.Line
              name="Temp. Salida Ciclón L1"
              data={tempCiclonL1.value}
              yAxis={0}
            />
            {/** -------------------------------- Temp. Salida Ciclón L2 --------------------------------------- */}
            <Chart.Line
              name="Temp. Salida Ciclón L2"
              data={tempCiclonL2.value}
              yAxis={0}
            />
            {/** -------------------------------- Temp. Entrada HESP --------------------------------------- */}
            <Chart.Line
              name="Temp. Entrada HESP"
              data={tempEntradaHESP.value}
              yAxis={0}
            />
            {/** -------------------------------- Temp. Salida CPC --------------------------------------- */}
            <Chart.Line
              name="Temp. Salida CPC"
              data={tempSalidaCPC.value}
              yAxis={0}
            />
            {/** -------------------------------- Temp. Salida Torre Enfriamiento --------------------------------------- */}
            <Chart.Line
              name="Temp. Salida Torre Enfriamiento"
              data={tempSalidaTorre.value}
              yAxis={0}
            />
            {/** -------------------------------- Temp. Salida HESP --------------------------------------- */}
            <Chart.Line
              name="Temp. Salida HESP"
              data={tempSalidaHESP.value}
              yAxis={0}
            />

            {/** -------------------------------- FECHAS --------------------------------------- */}
            <Chart.XAxis categories={tempFreeboardA.fecha} />

            <Chart.YAxis
              labelSuffix=" °C"
              title="Temperatura, °C"
              lineWidth={2}
              lineColor="white"
            />

            <Chart.YAxis
              labelSuffix=""
              title=""
              lineWidth={2}
              opposite={true}
              lineColor="white"
            />

            <Chart.Tooltip valueSuffix="" />
          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
